export default __webpack_public_path__ + "static/media/icon_refresh.1e01a5d0.svg";